import { Component, Input, OnInit, OnDestroy } from '@angular/core';


@Component({
  selector: 'my-tab',
  templateUrl: './tab.component.html',
  styles: [
    `
    .pane{
      padding: 1em;
    }
  `
  ]
})

export class TabComponent implements OnInit, OnDestroy {
  @Input('tabTitle') title: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template;
  @Input() dataContext;

  blnEsDashboard    : boolean = false;
  blnEsGantt	    : boolean = false;
  blnEsCheckout	    : boolean = false;
  blnEsOtraPantalla : boolean = false;

  strWsURL        : string   = "";

  ngOnInit(): void {
    if (this.dataContext != null) {
      this.blnEsDashboard    = false;
      this.blnEsOtraPantalla = false;
      this.blnEsGantt        = false;
      if (this.dataContext.SYS02TIP == "DASHBOARD") 
        this.blnEsDashboard = true;
      else if (this.dataContext.SYS02TIP == "GANTT") 
        this.blnEsGantt = true;
      else if (this.dataContext.SYS02TIP == "CHECKOUT") 
        this.blnEsCheckout = true;
      else 
        this.blnEsOtraPantalla = true;
        this.strWsURL = this.dataContext.url;
    }
  }

  ngOnDestroy() : void {

  }
}
